<template>
  <dir class="teacher" v-on="listeners" v-ripple>
    <div class="teacher__avatar">
      <app-avatar :id="teacher.avatar" :size="48" :isOnline="teacher.isOnline" />
    </div>
    <div class="teacher__info">
      <div class="subheading">{{name}}</div>
      <div class="white-space-nowrap subheading"><app-rating :value="teacher.rating || 0" fontSize="1.2rem" /></div>
      <div class="teacher__info__text mr-2">年資: {{teacher.years}}年</div>
      <div class="teacher__info__text mr-2">學制: {{teacher.schoolSystems | concatText}}</div>
      <div class="teacher__info__text">科目: {{teacher.subjects | concatText}}</div>
    </div>
    <div class="teacher__action">
      <app-favorite-button
        :isFavorite="teacher.isFavorite"
        @click.stop="toggleContactFavorite(teacher)" />

      <v-btn
        @click.stop="chat(teacher)"
        flat
        icon>
        <v-icon>chat</v-icon>
      </v-btn>
    </div>
  </dir>
</template>

<script>
import {mapActions} from 'vuex';

export default {
  props: {
    teacher: {
      type: Object,
      required: true,
      default: () => {}
    }
  },

  computed: {
    listeners() {
      return {
        ...this.$listeners
      };
    },

    name() {
      return this.teacher.nickname || this.teacher.username;
    }
  },

  filters: {
    concatText(v) {
      if (!v || v.length === 0) {
        return;
      }
      return v.map(item => item.text).join('/');
    }
  },

  methods: {
    ...mapActions('user', {
      toggleContactFavorite: 'toggleContactFavorite'
    }),

    ...mapActions('chat', {
      switchChat: 'switchChat'
    }),

    chat(teacher) {
      this.switchChat({username: teacher.username});
      this.changeRightPage('chat');
    }
  }
};
</script>

<style lang="stylus" scoped>

.teacher {
  display: flex;
  align-items: stretch;
  border-bottom: 1px solid rgba(0,0,0,0.12);
  transition: 0.2s;
  cursor: pointer;
  padding: 0.5rem;

  &:hover {
    background-color: $def-hover-color;
  }
}

.teacher__avatar,
.teacher__action {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem;
  flex-direction: column;
}

.teacher__avatar {
  width: 6rem;
  flex-shrink: 0;
}

.teacher__info {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  // The CSS: "text-overflow: ellipsis" of child element
  // will not work if the overflow is not hidden on parent element.
  overflow: hidden;
}

.teacher__info__text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
